import { httpClient } from "infra/axios/axios-api";
import { Employee } from "domain/entities/employee";

/**
 * Faz upload de um ficheiro (atestado) para o S3.
 * Devolve o filePath (caminho no storage).
 */
export const uploadAbsenceDocument = async ({
    file,
    employee,
    date,
}: {
    file: File | Blob;
    employee: Employee;
    date: Date;
}): Promise<string> => {
    const formData = new FormData();

    const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const extension = file instanceof File ? file.name.split(".").pop() ?? "jpg" : "jpg";
    const fileName = `${dateStr}-atestado.${extension}`;

    formData.append("file", file, fileName);

    const folder = `absences/${dateStr}/${employee.id}`;
    const uploadResponse = await httpClient.post(`/assets/${folder}`, formData);

    return uploadResponse.data.filePath;
};